// Чистые хелперы работы с JWT (без проверки подписи — только для UI-состояния).

export interface JwtClaims {
  sub?: string
  email?: string
  active_org_id?: number | null
  exp?: number // секунды epoch
}

/** Разобрать payload JWT. null при битом токене. */
export function decodeJwtClaims(token: string): JwtClaims | null {
  try {
    const payload = token.split('.')[1]
    if (!payload) return null
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(json) as JwtClaims
  } catch {
    return null
  }
}

/**
 * Протух ли access-токен. skewMs — запас, чтобы считать «почти протухший»
 * протухшим и упреждающе рефрешить (не ловить 401 на границе).
 * Битый токен → true (считаем непригодным). Токен без exp → false.
 */
export function isTokenExpired(token: string, skewMs = 5000, nowMs = Date.now()): boolean {
  const claims = decodeJwtClaims(token)
  if (!claims) return true
  if (!claims.exp) return false
  return claims.exp * 1000 <= nowMs + skewMs
}
